export default __webpack_public_path__ + "static/media/SSC.4fb538de.png";